<template>
  <div class="nomination-card">
    <button
      class="nomination-card__delete button button_sm button_square link link_light"
      :class="{'button_loading': deleting}"
      :disabled="deleting"
      type="button"
      @click="deleteNomination"
    >
      <span class="button__icon">
        <icon icon-name="delete"></icon>
      </span>
      <span class="button__icon button__loading">
        <icon icon-name='loading'></icon>
      </span>
    </button>
    <div class="nomination-card__container">
      <div class="nomination-card__col nomination-card__type">
        <div class="field">
          <div class="field__label">
            <label class="label text-md">Тип номинации</label>
          </div>
          <div class="field__input">
            <Select
              v-model="typeVal"
              :value="typeVal"
              :options="typeOptions"
              :searchable="false"
            >
            </Select>
          </div>
        </div>
      </div>
      <div class="nomination-card__col nomination-card__gender">
        <div class="field">
          <div class="field__label">
            <label class="label text-md">Пол</label>
          </div>
          <div class="field__input">
            <Select
              v-model="genderVal"
              :value="genderVal"
              :options="genderOptions"
              :searchable="false"
            >
            </Select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select from '@/components/Select'

export default {
  name: 'NominationCard',
  components: {
    Select
  },
  props: {
    id: String,
    type: String,
    gender: [String, Number],
    typeOptions: Array,
    genderOptions: Array
  },
  data () {
    return {
      deleting: false
    }
  },
  computed: {
    typeVal: {
      get () {
        return this.type
      },
      set (val) {
        this.onChange(val, this.gender)
      }
    },
    genderVal: {
      get () {
        return this.gender + ''
      },
      set (val) {
        this.onChange(this.type, val)
      }
    }
  },
  methods: {
    onChange (type, gender) {
      this.$emit('changed', {
        id: this.id,
        type,
        gender
      })
    },
    deleteNomination () {
      if (this.deleting) {
        return
      }
      this.deleting = true
      this.$emit('deleting', this.id)
    }
  }
}
</script>

<style lang="scss">
  .nomination-card {
    border: 2px solid map-get($color-neutral-black, 15);
    padding: 2px;
    border-radius: $border-radius;
    position: relative;

    .no-touch &:hover {
      box-shadow: none;
      border-color: map-get($color-neutral-black, 25);
    }

    &__container {
      margin: -12px -8px 0;
      padding: 16px 18px 32px;

      @media (min-width: breakpoint(sm)) {
        display: flex;
        align-items: flex-start;
      }
    }

    &__col {
      padding: 0 8px;
      margin-top: 12px;
    }

    &__type {

      @media (min-width: breakpoint(sm)) {
        width: 270px;
      }
    }

    &__gender {

      @media (min-width: breakpoint(sm)) {
        width: 160px;
      }
    }

    &__delete {
      position: absolute;
      top: 0;
      right: 0;
      margin: 3px;

      &::after {
        content: none;
      }
    }
  }
</style>
